import { Injectable } from "@angular/core";

import {
    HttpClient,
    HttpHeaders,
    HttpParams,
    HttpErrorResponse,
} from "@angular/common/http";

import { Observable, of, from } from "rxjs";
import { map, timeout, retry, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { User } from "src/app/Modals/user.model";

@Injectable({
    providedIn: "root",
})
export class AuthService {
    private token: string;

    //public picName:string = '';

    constructor(private httpClient: HttpClient, private router: Router) {}

    saveToken(token: string): void {
        if (this.token) {
            this.logout();
        }
        localStorage.setItem("token", token);
        this.token = token;
    }

    getToken(): string {
        //console.log(this.token)
        if (!this.token) {
            this.token = localStorage.getItem("userToken");
        }
        return this.token;
    }

    public getUserDetails() {
        const token = this.getToken();
        let payload;
        if (token) {
            // console.log(token);
            payload = token.split(".")[1];
            //console.log(payload);

            payload = window.atob(payload);
            // console.log(JSON.parse(payload));

            //console.log(payload)

            //this.picName = JSON.parse(payload).image

            return JSON.parse(payload);
        } else {
            return null;
        }
    }

    public isLoggedIn(): boolean {
        if (localStorage.getItem("token")) return true;
        else return false;

        // const user = this.getUserDetails();

        // if (localStorage.getItem("support") == "true") return true;
        // else if (user) {
        //     if (user.exp > Date.now() / 1000) {
        //         //console.log("true");
        //         return true;
        //     } else {
        //         //console.log("false");
        //         return false;
        //     }
        // } else {
        //     return false;
        // }
    }

    public login(email: string, password: string): Observable<any> {
        return this.httpClient
            .request("post", `${environment.apiUrl}` + "/user/login", {
                body: { email: email, password: password },
            })
            .pipe(
                map((res: any) => {
                    if (!res) return;

                    console.log(res);

                    if (res.success) {
                        this.saveToken(res["data"].token);
                        localStorage.setItem("userID", res["data"].id);
                    }

                    return res;
                })
            );
    }

    public register(user: User): Observable<any> {
        return this.httpClient
            .request("post", `${environment.apiUrl}` + "/user/register", {
                body: user,
            })
            .pipe(
                map((res: any) => {
                    if (!res) return;

                    console.log(res);

                    // if (res.success.token) this.saveToken(res.success.token);

                    return res;
                })
            );
    }

    public logout(): void {
        localStorage.clear();
        this.router.navigate(["/auth/login"]);
    }
}
